import React from "react";
import { OHeader, OButton } from "@dnvgl-onefoundation/onedesign-react";
import { Row, Col, Alert, Button, Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { SubscriptionLevel } from "../autogenerated/models";
import { subscriptionLabel } from "../utils/subscriptionCapabilities";

interface HeaderProps {
  routes: any[];
  appName: string;
  name: string | null;
  subscription: SubscriptionLevel;
  unshacledSubscription?: SubscriptionLevel;
}

const Header = (props: HeaderProps) => {
  const {
    routes = [],
    appName,
    name,
    subscription = SubscriptionLevel.None,
    unshacledSubscription,
  } = props;

  const subscriptionTooltip = (
    <>
      {/* CAS and unSHACLed are bought separately: only list what the user has */}
      {subscription !== SubscriptionLevel.None && <div>{subscriptionLabel(subscription)}</div>}
      {unshacledSubscription != null && unshacledSubscription !== SubscriptionLevel.None && (
        <div>{subscriptionLabel(unshacledSubscription)}</div>
      )}
    </>
  );

  return (
    <>
      <OHeader compact container={true} routes={routes}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="o-header-right">
                <span className="o-header-product">{appName}</span>
                {name && (
                  <Tooltip title={subscriptionTooltip} placement="bottom" overlayStyle={{ maxWidth: "none", whiteSpace: "nowrap" }}>
                    <span
                      className="o-header-user-name"
                      style={{ cursor: "help", borderBottom: "1px dotted currentColor" }}
                    >
                      {name}
                    </span>
                  </Tooltip>
                )}

                <a style={{ paddingLeft: "8px" }} href="/account/logout">
                  <OButton
                    variant="flat"
                    size="large"
                    iconClass="fad fa-sign-out"
                  ></OButton>
                </a>
              </div>
            </div>
          </div>
        </div>
      </OHeader>
      {subscription === SubscriptionLevel.Unpaid ? (
        <>
          <Row>
            <Col span={24}>
              <Alert
                description={
                  <div style={{ textAlign: "center" }}>
                    Your subscription has expired{" "}
                    <Button
                      type="dashed"
                      href="https://store.veracity.com/cimbion"
                    >
                      <LinkOutlined /> Renew
                    </Button>
                  </div>
                }
                type="warning"
                showIcon
              />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Header;
